import { setupAutoAnimate } from './auto-animate.js';

(function() {
  'use strict';

  /**
   * Initialize the filter functionality
   */
  function initFilters() {
    const scheduleGrids = Array.from(document.querySelectorAll('.schedule-grid'));
    const filterTrigger = document.querySelector('.filter-button-trigger');
    const filterOverlay = document.querySelector('.filter-button-overlay');
    const filterButtons = Array.from(document.querySelectorAll('.filter-button-overlay button[data-filter-is-home]'));

    if (scheduleGrids.length === 0 || !filterTrigger || !filterOverlay || filterButtons.length === 0) {
      return;
    }

    // Store original trigger content for "All matches"
    const originalTriggerContent = filterTrigger.querySelector('span').textContent.trim();

    // Toggle overlay visibility
    filterTrigger.addEventListener('click', function(e) {
      e.stopPropagation();
      const isOpen = filterOverlay.classList.contains('visible');
      if (isOpen) {
        filterOverlay.classList.remove('visible');
        filterTrigger.classList.remove('open');
      } else {
        filterOverlay.classList.add('visible');
        filterTrigger.classList.add('open');
      }
    });

    // Close overlay when clicking outside
    document.addEventListener('click', function(e) {
      if (!filterTrigger.contains(e.target) && !filterOverlay.contains(e.target)) {
        filterOverlay.classList.remove('visible');
        filterTrigger.classList.remove('open');
      }
    });

    // Update trigger button text when filter changes
    function updateTriggerText() {
      const activeButton = filterButtons.find(btn => btn.classList.contains('active'));
      const activeButtonText = activeButton.querySelector('span').textContent.trim();
      const filterTriggerText = filterTrigger.querySelector('span');
      if (activeButton) {
        filterTriggerText.textContent = activeButtonText;
      } else {
        filterTriggerText.textContent = originalTriggerContent;
      }
    }

    // Set up auto-animate
    setupAutoAnimate({
      elParents: scheduleGrids,
      elReset: null, // "All matches" button acts as a filter button with value "all"
      elFilterButtons: filterButtons,
      dataAttributeOnItems: 'gameIsHome',
      dataAttributeOnFilterButtons: 'filterIsHome',
      onFilterChange: function(hasActiveFilter) {
        updateTriggerText();
      }
    });

    // Add click handlers to close overlay after filter is applied
    filterButtons.forEach((button) => {
      // Add a listener that runs after the auto-animate handler
      button.addEventListener('click', function() {
        // Small delay to ensure auto-animate handler runs first
        setTimeout(() => {
          updateTriggerText();
          filterOverlay.classList.remove('visible');
          filterTrigger.classList.remove('open');
        }, 0);
      });
    });
  }

  /**
   * Smoothly scroll to the past games section when the "Past games" link is clicked
   */
  function initPastGamesLink() {
    const link = document.querySelector('.filter-button-link[href="#schedule-past"]');
    const target = document.getElementById('schedule-past');

    if (!link || !target) {
      return;
    }

    link.addEventListener('click', function(e) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function init() {
    initFilters();
    initPastGamesLink();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
